import React, { useContext, useEffect } from 'react';
import { RadioChangeEvent } from 'antd';
import { CoveragePlan } from 'all-in-one-shared-api';

import Usage from './Usage';
import OutpatientHeader from './components/OutpatientHeader';

import { OUTPATIENT_TYPES } from 'pages/benefits/types/benefitTypes';
import Coverage from 'pages/benefits/coverage/Coverage';
import BenefitContext from 'pages/benefits/contexts/BenefitContext';
import { useProfileInfoContext } from 'contexts/profileInfo';

const OutpatientBody = ({ selectedTab }: { selectedTab: OUTPATIENT_TYPES }): JSX.Element => {
  const Body = () => {
    switch (selectedTab) {
      case OUTPATIENT_TYPES.COVERAGE:
        return <Coverage coveragePlan={CoveragePlan.OUTPATIENT} />;
      case OUTPATIENT_TYPES.USAGE:
        return <Usage />;
      default:
        return <></>;
    }
  };
  return (
    <div style={{ marginTop: '24px' }}>
      <Body />
    </div>
  );
};

function Outpatient() {
  const { selectedFilterName, selectedOutpatientTab, setSelectedOutpatientTab } = useContext(BenefitContext);
  const { state: profileInfo } = useProfileInfoContext();
  const showUsage =
    profileInfo?.submitClaimForAll ||
    profileInfo?.memberType === '0' ||
    selectedFilterName.memberType === profileInfo?.memberType ||
    (Number(profileInfo?.memberType) <= 1 && Number(selectedFilterName.memberType) > 1);

  useEffect(() => {
    if (!showUsage) setSelectedOutpatientTab(OUTPATIENT_TYPES.COVERAGE);
  }, [showUsage, setSelectedOutpatientTab]);

  const handleOutpatientTabChange = (e: RadioChangeEvent) => setSelectedOutpatientTab(e.target.value);

  return (
    <>
      {showUsage && (
        <OutpatientHeader
          selectedOutpatientTab={selectedOutpatientTab}
          handleOutpatientTabChange={handleOutpatientTabChange}
        />
      )}
      <OutpatientBody selectedTab={selectedOutpatientTab} />
    </>
  );
}

export default Outpatient;
